import { useTheme } from '@automata/mui-theme';
import { Group } from '@visx/group';
import { line } from 'd3-shape';

const points = [
  [0, 0], // Starting point
  [10, 0], // Horizontal line to the right
  [10, 6],
  [10, 9],
  [5, 12], // Diagonal line to the middle bottom
  [0, 9],
  [0, 6],
  [0, 0], // Back to the start
] satisfies [number, number][];

export const playheadTip = (): string | null => {
  const path = line()(points);

  return path;
};

export const Playhead = ({ x, height }: { x: number; height: number }) => {
  const theme = useTheme();
  const path = playheadTip() ?? undefined;
  const xPos = x - 1.5;
  return (
    <Group>
      <rect
        data-testid="playhead-rect"
        x={xPos}
        y={0}
        width={3}
        height={Math.max(height, 0)}
        fill={theme.palette.accent2[400]}
      />
      <g transform={`translate(${xPos - 3.5}, 0)`}>
        <path d={path} fill={theme.palette.accent2[400]} />
      </g>
    </Group>
  );
};
